

































































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Case, CaseType } from '@/modules/Case/interfaces/case'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import FoldingCard from '@/components/FoldingCard.vue'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard
  }
})
export default class CaseDetailPolicy extends mixins(PolicyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  tableColumn = [
    { field: 'policyNumber',
      title: 'Policy Number',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.policyNumber || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'policyName',
      title: 'Policy Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'status', title: 'Status', slots: { default: 'status_default' }, resizable: true, width: 140 },
    { field: 'carrierName',
      title: 'Carrier',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.carrier ? row.carrier.name : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'premium',
      title: 'Premium',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.premium ? dollarFilter(row.premium) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'effectiveDate',
      title: 'Effcetive Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.effectiveDate ? dateToDisplay(row.effectiveDate) : '-')
        ]
      }
      },
      resizable: true,
      width: 150
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.expirationDate ? dateToDisplay(row.expirationDate) : '-')
        ]
      }
      },
      width: 150
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  limitOnePolicyTypes = [
    CaseType.BOR,
    CaseType.ENDORSEMENT,
    CaseType.RENEWAL,
    CaseType.REWRITE,
    CaseType.REMARKET
  ]

  limitNoPolicyTypes = [
    CaseType.CANCELLATION,
    CaseType.ENDORSEMENT
  ]

  get policyList () {
    return this.caseInfo.policies || []
  }

  get relatedPolicyList () {
    return this.caseInfo.relatedPolicies || []
  }

  get ifCanAddPolicy () {
    return !(this.$R.contains(this.caseInfo.type)(this.limitOnePolicyTypes) && !this.$R.isEmpty(this.caseInfo.policies)) && !(this.$R.contains(this.caseInfo.type)(this.limitNoPolicyTypes))
  }

  get ifEndorsement () {
    return this.caseInfo.type === CaseType.ENDORSEMENT
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  policyStatus = policyStatus
  policyStatusClass = policyStatusClass

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  async deletePolicyConfirm () {
    await this.deletePolicyPost()
    this.onSuccess()
  }

  routeToAllList (type: string) {
    this.$router.push({
      name: 'CaseRelatedPoliciesList',
      params: {
        id: this.caseInfo.id + '',
        type: type,
        fromName: this.caseInfo.inquiryName
      }
    })
  }
}
